export default class FiltrosReporteHistoriaEntity {

    codigBaseDatos: string;
    tta: number;
    nodo: number;
    firmaProfesional: boolean;
    firmaAfiliado: boolean;
    diligenciados: boolean;
    evoluciones: boolean;
    notas: boolean;
    solicitudServicios: boolean;
    sede: number;
    user: number;
    type: string;
    permisos: number;

    constructor() {
        this.type = 'html';
    }

    isPDF() {
        return this.type === 'pdf';
    }
}